export default function DeliveryPreviewCard({ settings }) {
  if (!settings) return null;
  return (
    <aside className="delivery-preview-card">
      <span className="admin-eyebrow">Live Storefront Preview</span>
      <h2>{settings.delivery_page_heading}</h2>
      <p>{settings.delivery_page_subheading}</p>
      <div className="delivery-preview-badges"><span>Delivery only</span><span>Free within {settings.free_delivery_radius_minutes} minutes of {settings.origin_city}</span><span>{settings.minimum_notice_days} days notice required</span></div>
      <p>{settings.general_delivery_message}</p>
      <p>{settings.address_privacy_message}</p>
    </aside>
  );
}
